import React, { useState } from 'react';
import styles from "./pagination.module.css"
import ReactPaginate from 'react-paginate';
import useDirection from "../../hooks/useDirection";
const Pagination = ({ itemsPerPage = 15, item = undefined, changePage, total, last_page, forcePage = -1 }) => {
  const [itemOffset, setItemOffset] = useState(0);
  const items = item || [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

  const pageCount = Math.ceil((total || items.length) / itemsPerPage);
  const directionClass = useDirection();

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    changePage(event.selected + 1)
  };

  return (
    last_page > 1 &&
    <div className={styles.pagination}>
      <>
        <ReactPaginate
          breakLabel="..."
          nextLabel={<div className={`${!directionClass && "rotate-180"}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.3254 0.953755C5.53506 1.13347 5.55934 1.44912 5.37963 1.65878L1.65854 6.00005L5.37963 10.3413C5.55934 10.551 5.53506 10.8666 5.3254 11.0463C5.11573 11.2261 4.80008 11.2018 4.62037 10.9921L0.620372 6.32545C0.459876 6.1382 0.459876 5.8619 0.620372 5.67465L4.62037 1.00799C4.80008 0.798324 5.11573 0.774044 5.3254 0.953755Z" fill="#56ADFF" />
            </svg>
          </div>}
          onPageChange={handlePageClick}
          pageRangeDisplayed={itemsPerPage}
          pageCount={last_page}
          previousLabel={<div><svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.674613 0.953755C0.884276 0.774044 1.19993 0.798324 1.37964 1.00799L5.37964 5.67465C5.54013 5.8619 5.54013 6.1382 5.37964 6.32545L1.37964 10.9921C1.19993 11.2018 0.884276 11.2261 0.674613 11.0463C0.46495 10.8666 0.44067 10.551 0.620381 10.3413L4.34147 6.00005L0.620381 1.65878C0.44067 1.44912 0.46495 1.13347 0.674613 0.953755Z" fill="#56ADFF" />
          </svg></div>}
          renderOnZeroPageCount={null}
          {...(forcePage != -1 ? ({ forcePage }) : {})}
        />
      </>
    </div>
  );
};

export default Pagination;
